import React, {useContext, useRef} from "react";

import {useNavigation} from '@react-navigation/native'

import {View, BackHandler}  from 'react-native';

import * as util from '../util/util'

import {novoItem} from '../ws/ws_itens'

import contexto from '../util/contexto'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import FormularioItem from '../componentes/FormularioItem'

import { useFocusEffect } from '@react-navigation/native';

import {ITEM_TIPO_PRODUTO, TELA_MEUS_ITENS} from '../util/constantes'

import Scroll from '../componentes/Scroll'




export default function TelaNovoItem(){
   
    const navegacao = new useNavigation();

	const {valorContexto} = useContext(contexto);

    const formularioItemRef  = useRef(null)
	

	const voltar = () => {
		navegacao.replace(util.processaVoltar())
		return true;
	};
	

	useFocusEffect(React.useCallback(() => {

		util.print("TelaNovoItem");
	
		BackHandler.addEventListener('hardwareBackPress', voltar);

		formularioItemRef.current.setDados({tipo: ITEM_TIPO_PRODUTO, valor: "0.00"}, null);
		
		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	

    async function salvar(item){
		
		item['id_usuario'] = valorContexto.idUsuarioAtual;
		
        let retorno  = await novoItem(item);

        if(retorno == null || retorno.id ==null){
             
			formularioItemRef.current.salvarErro(retorno.mensagem);
            return;
        }

        formularioItemRef.current.salvarSucesso();
		
		navegacao.replace(TELA_MEUS_ITENS)
    }


    return (
		<ViewDegradeVertical titulo="Novo Produto/Serviço" voltar={()=>voltar()}>  
			<Scroll> 
                <View>                
                    <FormularioItem ref={formularioItemRef} salvar={salvar}/>
				</View>
            </Scroll>       
        </ViewDegradeVertical>)
}